import UAParser from 'ua-parser-js';

class Detection {
    constructor() {
        this.parser = new UAParser();
        this.device = this.parser.getResult();
        this.result();
    }

    result() {
        // console.log('browser:: ', this.device.browser);
        // console.log('device:: ', this.device.device);
        // console.log('os:: ', this.device.os);
        // console.log('version:: ', this.device.os.version);
        // console.log('engine:: ',this.device.engine.name);
        // console.log('cpu:: ', this.device.cpu.architecture);
    }

    isMobile() {
        if (this.device.device.type === 'mobile') {
            return true;
        }
        return false;
    }

    isChrome() {
        if (this.device.browser.name === 'Chrome') {
            return true;
        }
        return false;
    }

    isSafari() {
        if (this.device.browser.name === 'Mobile Safari') {
            return true;
        }
        return false;
    }

    isAndroid() {
        if (this.device.os.name === 'Android') {
            return true;
        }
        return false;
    }

    isIOS() {
        if (this.device.os.name === 'iOS') {
            return true;
        }
        return false;
    }

    isMotoGPlay() {
        if (this.device.device.model === 'Moto G6 Play') {
            return true;
        }
        return false;
    }
}

export default Detection;
